module.exports = __webpack_public_path__ + "img/invoice_create_un.6b66a9ac.png";